import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import Manifesto from "./sections/Manifesto";
import PortfolioGrid from "./sections/PortfolioGrid";
import Splash from "./sections/Splash";
export default function HomePage() {
  return <div>
      <Splash />
      <Header />
      <HeroSection />
      <Manifesto />
      <PortfolioGrid />
    </div>;
}